// These schemas should match their corresponding DB model in @performyard/models
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Autoflow () {
        return Autoflow;
    },
    get AutoflowModel () {
        return AutoflowModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _tasks = require("./tasks");
const _trigger = require("./trigger");
const Autoflow = _zod.z.object({
    enabled: _zod.z.boolean().default(true),
    trigger: _trigger.AutoflowTrigger,
    tasks: _tasks.AutoflowTask.array()
});
const AutoflowModel = Autoflow.extend({
    _id: _utilsisomorphic.transformObjectId.or(_zod.z.instanceof(_bson.ObjectId)),
    resourceId: _utilsisomorphic.transformObjectId.or(_zod.z.instanceof(_bson.ObjectId)).optional(),
    companyId: _utilsisomorphic.transformObjectId.or(_zod.z.instanceof(_bson.ObjectId)).optional(),
    name: _zod.z.string().optional(),
    createdAt: _utilsisomorphic.transformDate.optional(),
    updatedAt: _utilsisomorphic.transformDate.optional(),
    deletedAt: _utilsisomorphic.transformDate.optional()
});
